<div class="modal-header border-0 pb-2" [ngClass]="getHeaderClass()">
  <div class="d-flex align-items-center w-100">
    <i [ngClass]="getIconClass()" class="me-3 fs-1"></i>
    <div class="flex-grow-1">
      <h4 class="modal-title mb-0 fw-bold">{{ title }}</h4>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body py-4">
  <div class="error-content">
    <!-- Mensaje principal -->
    <div class="main-message mb-3" *ngIf="message">
      <p class="fs-5 mb-0 text-dark">{{ message }}</p>
    </div>

    <!-- Detalles expandibles -->
    <div class="error-details" *ngIf="details">
      <div class="card border-0 bg-light">
        <div class="card-body p-3">
          <h6 class="card-title text-muted mb-2">
            <i class="fas fa-info-circle me-2"></i>{{ 'details' | translate }}:
          </h6>
          <pre class="text-dark mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ details }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-2">
  <!-- Botones para advertencias con opción de continuar -->
  <div *ngIf="showTwoButtons" class="d-flex gap-2 w-100">
    <button type="button" class="btn btn-outline-secondary px-4" (click)="dismiss()">
      <i class="fas fa-times me-2"></i>{{ 'cancelAndReview' | translate }}
    </button>
    <button type="button" class="btn btn-warning px-4" (click)="confirm()">
      <i class="fas fa-save me-2"></i>{{ 'continueAndSave' | translate }}
    </button>
  </div>

  <!-- Botón único para errores e info -->
  <button *ngIf="!showTwoButtons" type="button" class="btn btn-primary px-4" (click)="close()">
    <i class="fas fa-check me-2"></i>{{ 'understood' | translate }}
  </button>
</div>
